var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback } from "react";
import styled from "styled-components";
var SVG = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: \"SF Pro Text\", \"SF Pro Icons\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n"], ["\n  font-family: \"SF Pro Text\", \"SF Pro Icons\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n"])));
var Text = styled.text(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  fill: ", ";\n"], ["\n  fill: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorContent();
});
var MainSpan = styled.tspan(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 0.525rem;\n  font-weight: bold;\n"], ["\n  font-size: 0.525rem;\n  font-weight: bold;\n"])));
var SubSpan = styled.tspan(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 0.45rem;\n  font-weight: bold;\n"], ["\n  font-size: 0.45rem;\n  font-weight: bold;\n"])));
var FullCircle = styled.circle(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  stroke: rgba(150, 150, 150, 0.2);\n"], ["\n  stroke: rgba(150, 150, 150, 0.2);\n"])));
var radius = 20;
var circumference = radius * 2 * Math.PI;
var CircleMeter = function (_a) {
    var heightAndWidth = _a.heightAndWidth, value = _a.value, maxValue = _a.maxValue, mainText = _a.mainText, subText = _a.subText, gradient = _a.gradient;
    var getPaths = useCallback(function () {
        var paths = [
            {
                d: "M -0.349,-19.997 A 20,20 0 0,1 17.32,-10",
                strokeDasharray: circumference * (61 / 360),
            },
            // "M 17.32,-10 A 20,20 0 0,1 17.32,10",
            {
                d: "M 17.143,-10.3 A 20,20 0 0,1 17.143,10.3",
                strokeDasharray: circumference * (62 / 360),
            },
            {
                d: "M 17.32,10 A 20,20 0 0,1 -0.349,19.997",
                strokeDasharray: circumference * (61 / 360),
            },
            {
                d: "M 0,20 A 20,20 0 0,1 -17.32,10",
                strokeDasharray: circumference / 6,
            },
            {
                d: "M -17.143,10.3 A 20,20 0 0,1 -17.143,-10.3",
                strokeDasharray: circumference * (62 / 360),
            },
            {
                d: "M -17.32,-10 A 20,20 0 0,1 0,-20",
                strokeDasharray: circumference / 6,
            },
        ];
        var percent = value / maxValue;
        return paths.map(function (path, index) {
            var stroke = "url(#".concat(gradient, "_circleGradient").concat(index + 1, ")");
            var strokeDashoffet = 0;
            var strokeLinecap = "butt";
            var totalCirc = circumference * percent;
            if (percent <= (index + 1) / paths.length) {
                if (percent > index / paths.length) {
                    strokeDashoffet = circumference / 6 - (totalCirc - circumference * (index / paths.length));
                    strokeLinecap = "butt";
                }
                else {
                    strokeDashoffet = path.strokeDasharray * 1;
                }
            }
            return (React.createElement("path", { key: path.d, d: path.d, stroke: stroke, strokeLinecap: strokeLinecap, strokeDasharray: "".concat(path.strokeDasharray, " ").concat(path.strokeDasharray), strokeDashoffset: strokeDashoffet, strokeLinejoin: "round" }));
        });
    }, [value, maxValue]);
    return (React.createElement(SVG, { xmlns: "http://www.w3.org/2000/svg", version: "1.1", height: heightAndWidth, width: heightAndWidth, viewBox: "-10 -10 45 45" },
        React.createElement(FullCircle, { r: "20", fill: "none", strokeWidth: "5", transform: "translate(12.5,12.5)" }),
        React.createElement("g", { fill: "none", strokeWidth: "5", transform: "translate(12.5,12.5)" }, getPaths()),
        React.createElement(Text, { x: "12.5", y: "11.5", textAnchor: "middle" },
            React.createElement(MainSpan, { x: "12.5" }, "".concat(mainText)),
            React.createElement(SubSpan, { x: "12.5", dy: "1.3em" }, subText))));
};
export default CircleMeter;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
